import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "environments/environment.js";

const mutation = graphql`
  mutation setThanksMailHourMutation($input: setThankYouEmailHourInput!) {
    setThankYouEmailHour(input: $input) {
      hyevent {
        id
        thankYouEmailHour
      }
    }
  }
`;

function commit(input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej,
    });
  });
}

export default commit;
